import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Session } from 'src/app/interfaces/session-data';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-mobicred-payment-method',
  templateUrl: './mobicred.component.html',
  styleUrls: ['./mobicred.component.scss']
})
export class MobicredComponent implements OnInit {
  public link:string;
  private lock: boolean = false;
    private session:Session;
  constructor(
    private router:Router,
    private sessionService:SessionService,
    private route: ActivatedRoute
  ) {
    this.link = "mobicred/login";
  }

  ngOnInit(): void {
    this.session = sessionStorage.getItem("sessionData")? JSON.parse(sessionStorage.getItem("sessionData")) : null;
    this.selectMethod();
    this.sessionService.getPaymentMethodListLock().subscribe((lock:boolean) => {
      this.lock = lock;
    });
  }

  toggleListView(){
    this.sessionService.emitPaymentMethodPromotion("mobicred");
  }

  selectMethod(event?: Event){
    sessionStorage.setItem("selected-payment","mobicred");
    if(event!=undefined&&!this.lock){
      this.sessionService.setSelectedChargeAmount({
        currency:this.session.sessionDisplayInformation.currencyCode,
        amount:this.session.sessionDisplayInformation.amount
      });
      this.sessionService.setCurrencyCodeListLock(true);
      this.sessionService.emitSelectedPaymentMethod("mobicred");
      this.router.navigate([this.link],{relativeTo: this.route});
    }
  }
}
